export default "__VITE_ASSET__DX0Sl3eU__"